import React, {useState} from 'react';
import {ReportForm} from "../../components";
import {Card, CardContent, Grid} from '@material-ui/core';
import {DateInput, required, Title} from 'react-admin';
import env from "../../env";
import moment from 'moment'
import {downloadFilePost} from "../../components/FileDownload";


const BcChiTieu = ({...props}) => {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
    });
    let timeout;

    function excelReport() {
        setLoading(true)
        const data = {
            fromDate: values.fromDate,
            toDate: values.toDate,
        }
        downloadFilePost(`${env.reportURL}/reports/bc-chi-tieu`, 'bc-chi-tieu.xlsx', data).then(r => setLoading(false)).catch(e => setLoading(false))
    }

    function validate(val) {
        const errors = {};

        if (val.fromDate && val.toDate && (val.fromDate > val.toDate)) {
            errors.toDate = 'To date must be greater than From date'
        }

        setValues({
            ...values,
            fromDate: val.fromDate,
            toDate: val.toDate
        })

        return errors;
    }

    return (
        <Card>
            <Title title="resources.bc-chi-tieu.name"/>
            <CardContent>
                <ReportForm validate={validate}
                            excelReport={excelReport}
                            params={values}
                            isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput source="fromDate" validate={required()} {...props}
                                       label={'resources.common.fromDate'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput source="toDate" validate={required()} {...props}
                                       label={'resources.common.toDate'}/>
                        </Grid>

                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default BcChiTieu
